import {
    TOGGLE_MODAL,
} from './actionTypes';

export const toggleModal = (name) => ({
    type: TOGGLE_MODAL,
    payload: name,
});



// WEBPACK FOOTER //
// ./src/actions/modalActions.js